<template>
  <div>
    <div>
      <h2
        class="mt-0 text-left slide-title-style"
        :class="{'mb-0': slide.titleDesc, 'clickable': clickable}"
        v-if="slide.title"
        v-html="dataValue"
      />
      <p class="mb-3 text-left slide-title-style title-desc" v-if="slide.titleDesc">
        {{ slide.titleDesc }}
      </p>

      <div
        class="p-16 audio-control-slide"
        v-if="slide.audioLink && slide.audioPlayOnAudience && slide.id"
      >
        <AudioControl />
      </div>
      <div v-if="slide.SlideOptions">
        <ScaleQuestion v-if="slide.type == 'scale'" />
        <MultipleChoice v-else :answered-slide-ids="answeredSlideIds" />
      </div>
    </div>
    <div
      class="text-center no-data"
      v-if="!slide.title && !slide.SlideOptions && !slide.titleDesc || !slide.title && !slide.SlideOptions.length && !slide.titleDesc"
    >
      {{ $t("blankSlide") }}
    </div>
  </div>
</template>

<script>
import MultipleChoice from '@/components/MultipleChoice'
import ScaleQuestion from '@/components/ScaleQuestion'
import EvenBus from '@/eventBus'
import AudioControl from '@/components/AudioControl.vue'
import storage from '@/services/storage'
import { mapGetters } from 'vuex'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'

export default {
  components: {
    MultipleChoice,
    AudioControl,
    ScaleQuestion,
  },
  mixins: [ClickableTitleMixin],
  data() {
    return {
      status: 1,
      answeredSlideIds: [],
    }
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  created() {
    this.checkVoting()
  },
  mounted() {
    EvenBus.$on('multiple-choice-voted', (data) => {
      this.checkVoting(data)
    })
  },
  destroyed() {
    EvenBus.$off('multiple-choice-voted')
  },
  methods: {
    checkVoting(data) {
      const slideId = this.slide.id
      const presentationId = this.$store.state.presentation.id
      if (this.slide.type === 'scale') {
        const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
        if (answeredSlideIds.includes(slideId)) {
          this.$store.dispatch('updateSlide', {
            multipleChoiceStatus: 2, // submited answer
          })
        }
      } else {
        const answeredSlides = storage.getValueByPresentation(presentationId, 'answeredSlides', {})
        if ((answeredSlides[slideId] && answeredSlides[slideId].vote) || data) {
          this.answeredSlideIds = answeredSlides[slideId].vote
          this.$store.dispatch('updateSlide', {
            multipleChoiceStatus: 2, // submited answer
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

h2, .title-desc {
  padding: 0 16px;
}

.no-data {
  padding: 16px;
}

.text-left {
  word-break: break-word;
  // white-space: pre-wrap;
  -o-word-wrap: normal;
  -ms-word-wrap: normal;
  word-wrap: normal;
}

.audio-control-slide {
  margin-bottom: 16px;
}

.progress-bar-time-limit {
  position: relative;
  margin-bottom: 16px;
  padding-top: 20px;
  border: 1px solid transparent;
}

</style>
